import { IProductSizeSort, ISizeOption } from 'pages/ProductDetail/hooks/types';
import { useSiteConfig } from 'modules/shop/siteConfig/hooks';

export const useProductSizeSort = (): IProductSizeSort => {
  const { productDetail } = useSiteConfig();

  const sortOrder =
    productDetail?.sizesSortOrder?.split('\n')?.map((label) => label.trim()) ||
    [];

  const sizeSort = (sizeA: ISizeOption, sizeB: ISizeOption) => {
    const orderA = sortOrder.findIndex(
      (sizeLabel) => sizeLabel === sizeA.label,
    );
    const orderB = sortOrder.findIndex(
      (sizeLabel) => sizeLabel === sizeB.label,
    );

    if (orderA > orderB) {
      return 1;
    }

    if (orderA < orderB) {
      return -1;
    }

    return 0;
  };

  const numericSort = (sizeA: ISizeOption, sizeB: ISizeOption): number => {
    const [labelA, labelB] = [sizeA.label || '', sizeB.label || ''];
    const [numA, numB] = [parseFloat(labelA), parseFloat(labelB)];

    if (Number(numA) && Number(numB)) {
      return numB - numA;
    }

    return 0;
  };

  return {
    sizeSort,
    numericSort,
  };
};
